module.exports = __webpack_public_path__ + "assets/img/icon-802.b5b6dbbb.png";